<template>
  <svg width="296" height="34" viewBox="0 0 296 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M296 17.4463C296 8.33359 229.738 0.946289 148 0.946289C66.2619 0.946289 0 8.33359 0 17.4463C0 26.559 66.2619 33.9463 148 33.9463C229.738 33.9463 296 26.559 296 17.4463Z" fill="url(#paint0_linear_1338_9034)"/>
    <defs>
      <linearGradient id="paint0_linear_1338_9034" x1="148" y1="27.9463" x2="148" y2="0.946289" gradientUnits="userSpaceOnUse">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="#F8F8F8"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name:'BackGround',
}
</script>